import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { DATE_PICKER_MONTH_NAMES } from '../constants';
export var DateVector = /*#__PURE__*/function () {
  function DateVector(date) {
    var _this = this;
    _classCallCheck(this, DateVector);
    this.date = date;
    // todo: this method only check equality down to days, so technically the naming is incorrect
    // todo: rename
    this.isEqualTo = function (vector) {
      if (!vector) {
        return false;
      }
      var month = _this.month,
        day = _this.day,
        year = _this.year;
      return month === vector.month && day === vector.day && year === vector.year;
    };
  }
  _createClass(DateVector, [{
    key: "clone",
    value: function clone() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        hour = _ref.hour,
        minute = _ref.minute,
        year = _ref.year,
        month = _ref.month,
        day = _ref.day;
      var date = this.date;
      return new DateVector(new Date(Date.UTC(year !== undefined ? year : date.getUTCFullYear(), month !== undefined ? month : date.getUTCMonth(), day !== undefined ? day : date.getUTCDate(), hour !== undefined ? hour : date.getUTCHours(), minute !== undefined ? minute : date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds())));
    }
  }, {
    key: "convertToLocalDate",
    value: function convertToLocalDate() {
      var date = this.date;
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    }
  }, {
    key: "isGreaterThanOrEqual",
    value: function isGreaterThanOrEqual(vector) {
      if (!vector) {
        return false;
      }
      return this.getWeight() >= vector.getWeight();
    }
  }, {
    key: "isSmallerThanOrEqual",
    value: function isSmallerThanOrEqual(vector) {
      if (!vector) {
        return false;
      }
      return this.getWeight() <= vector.getWeight();
    }
    // todo: this method not only adds amount of months, but also resets the day to 1
    // todo: therefore, the naming is not entirely correct
    // todo: rename
    // todo: also, the method mutates the object, which is not good
  }, {
    key: "addMonth",
    value: function addMonth() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var date = this.date;
      date.setUTCDate(1);
      date.setUTCMonth(date.getUTCMonth() + amount);
    }
    // todo: this method mutates the object, which is not good
  }, {
    key: "addDay",
    value: function addDay() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var date = this.date;
      date.setUTCDate(date.getUTCDate() + amount);
    }
    // todo: this method mutates the object, which is not good
  }, {
    key: "addMinute",
    value: function addMinute() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var date = this.date;
      date.setUTCMinutes(date.getUTCMinutes() + amount);
    }
    // todo: this method mutates the object, which is not good
  }, {
    key: "resetTime",
    value: function resetTime() {
      this.date.setUTCHours(0, 0, 0, 0);
    }
  }, {
    key: "hour",
    get: function get() {
      return this.date.getUTCHours();
    }
  }, {
    key: "minute",
    get: function get() {
      return this.date.getUTCMinutes();
    }
  }, {
    key: "day",
    get: function get() {
      return this.date.getUTCDate();
    }
  }, {
    key: "month",
    get: function get() {
      return this.date.getUTCMonth();
    }
  }, {
    key: "year",
    get: function get() {
      return this.date.getUTCFullYear();
    }
  }, {
    key: "timeStamp",
    get: function get() {
      return this.date.getTime();
    }
  }, {
    key: "weekDay",
    get: function get() {
      return this.date.getUTCDay();
    }
  }, {
    key: "formattedHour",
    get: function get() {
      return this.hour.toString().padStart(2, '0');
    }
  }, {
    key: "formattedMinute",
    get: function get() {
      return this.minute.toString().padStart(2, '0');
    }
  }, {
    key: "formattedDay",
    get: function get() {
      return this.day.toString().padStart(2, '0');
    }
  }, {
    key: "formattedMonth",
    get: function get() {
      return (this.month + 1).toString().padStart(2, '0');
    }
  }, {
    key: "formattedYear",
    get: function get() {
      return this.year.toString();
    }
  }, {
    key: "monthName",
    get: function get() {
      return DATE_PICKER_MONTH_NAMES[this.month];
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.formattedDay, ".").concat(this.formattedMonth, ".").concat(this.formattedYear, " ").concat(this.formattedHour, ":").concat(this.formattedMinute, ":00");
    }
  }, {
    key: "getWeight",
    value: function getWeight() {
      var year = this.year,
        month = this.month,
        day = this.day;
      return new Date(year, month, day).getTime(); // get rid of time different when comparing dates
    }
  }], [{
    key: "createFromLocalDate",
    value: function createFromLocalDate(date) {
      var sourceDate = date || new Date();
      return new this(new Date(Date.UTC(sourceDate.getFullYear(), sourceDate.getMonth(), sourceDate.getDate(), sourceDate.getHours(), sourceDate.getMinutes(), sourceDate.getSeconds(), sourceDate.getMilliseconds())));
    }
  }, {
    key: "createFromStructure",
    value: function createFromStructure(_ref2) {
      var year = _ref2.year,
        month = _ref2.month,
        day = _ref2.day,
        hour = _ref2.hour,
        minute = _ref2.minute;
      return new this(new Date(Date.UTC(year, month, day !== undefined ? day : 1, hour !== undefined ? hour : 0, minute !== undefined ? minute : 0)));
    }
  }, {
    key: "createFromMetaString",
    value: function createFromMetaString(meta, _ref3) {
      var currentDateVector = _ref3.currentDateVector;
      var match = meta.trim().match(/current(([+-])(\d+))?/);
      if (match && currentDateVector) {
        var _match = _slicedToArray(match, 4),
          op = _match[2],
          amount = _match[3];
        var result = currentDateVector.clone();
        if (amount && op === '+') {
          result.addDay(parseInt(amount, 10));
        }
        if (amount && op === '-') {
          result.addDay(parseInt(amount, 10) * -1);
        }
        return result;
      }
      return null;
    }
  }]);
  return DateVector;
}();